<template>
  <div>
    <DevNotes>
      Advisor : 0%
      Development Notes
      - แสดงการ Chat กับที่อาจารย์ปรึกษา
    </DevNotes>

    <component :is="getCurrentStage().k" :classroomId="classroomId"/> 

  </div>
</template>

<script>
import { getCurrentStage } from "@/developing/dev-data";
import { bulkImportComponent } from "@/developing/utils/modular";

export default {
  components: {
    DevNotes: () => import("@/developing/dev-components/DevNotes"),
    ...bulkImportComponent("components/advisor")
    // production: () => import("./index"),
    // development: () => import("./dev")
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  watch: {
    // "classroomId": function (curr, prev) {
    //   if (curr !== prev) this.$forceUpdate();
    // }
  },
  methods: {
    getCurrentStage,
  },
  // beforeCreate() {
  //   if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  // },
  // destroyed() {
  //   this.$store.unregisterModule(StoreModuleName);
  // },
}
</script>
